import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";
import {MetricDefinitionSearch} from "./MetricDefinitionSearch";

const vUI_Metric_View_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_MTRVIEW_ID:        {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Metric View Id', columnResourceName: 'colWbId',           alignment: HorizAlignment.Center}, domainOptions: {}},
    METRIC_VIEW_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric View Id',    columnResourceName: 'colId',             alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
    METRIC_VIEW_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric View Name',  columnResourceName: 'colName',           alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256 }},
    METRIC_VIEW_USAGE:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric View Usage', columnResourceName: 'colUsage',          alignment: HorizAlignment.Left},   domainOptions: { profileId: "default", bUseSearchProvidersDistinctValues: true, domainIds: ['Metric_Usage'], useIdAsKey: true, maxLength: 256}},
    CUBESOURCE_ID:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'CubeSource Id',     columnResourceName: 'colCubeSourceId',   alignment: HorizAlignment.Left},   domainOptions: { profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    CUBESOURCE_NAME:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'CubeSource Name',   columnResourceName: 'colCubeSourceName', alignment: HorizAlignment.Left},   domainOptions: { profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    SORT_ORDER:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Sort Order',        columnResourceName: 'colSortOrder',      alignment: HorizAlignment.Left},   domainOptions: { }},
    METRIC_COUNT:         {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Metric Count',      columnResourceName: 'colMetricCount',    alignment: HorizAlignment.Left},   domainOptions: { }},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const MetricViewSearchProviderBasic: ISearchProvider =
    {
        keyFields: {id:        'WB_MTRVIEW_ID',
                    id_ui:     'METRIC_VIEW_ID',
                    name:      'METRIC_VIEW_NAME'
        },

        searchProviderFields: vUI_Metric_View_Search_Fields,


        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {

                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vUI_Metric_View_Search',
                    this.searchProviderFields,
                    [])

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(res)
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        },

        distinctValues(fieldName: string, condition?: any): Promise<string[] | number[]> {
            return new Promise<string[] | number[]>((resolve, error) => {
                let findRequest = SearchUtils.makeSearchRequest({},
                    'vUI_Metric_View_Search',
                    this.searchProviderFields,
                    [fieldName])

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {

                        resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        }

    }


const MetricViewSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "MetricViewSearchProfileByName" },


    profileFilter: [
        {profileFilterName: 'Metric View Id',    searchProviderFieldId: 'METRIC_VIEW_ID',   renderOptions: { }},
        {profileFilterName: 'Metric View Name',  searchProviderFieldId: 'METRIC_VIEW_NAME',   renderOptions: { }},
        {profileFilterName: 'Metric Usage',      searchProviderFieldId: 'METRIC_VIEW_USAGE',   renderOptions: { }, bMultiSelect: true},
        {profileFilterName: 'Cube Source',       searchProviderFieldId: 'CUBESOURCE_NAME',   renderOptions: { }, bMultiSelect: true}
    ],  // ISearchFields
    profileDisplayFields: [
        'METRIC_VIEW_ID',    'METRIC_VIEW_NAME',
        'METRIC_VIEW_USAGE', 'CUBESOURCE_NAME',
        'SORT_ORDER',        'METRIC_COUNT',
        'CREATED_DTTS',      'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: MetricViewSearchProviderBasic,

    profileTreeIdDefault: "ByCubeSource",
    profileTrees: [
        {treeId: "ByCubeSource",
            treeName: "By CubeSource ",
            nodeProviders: [new ColumnNodeProvider(['CUBESOURCE_NAME'], {defaultValues: "Empty CubeSource"})],
            renderOptions: {}},
        {treeId: "ByMetricViewUsage",
            treeName: "By Metric View Usage",
            nodeProviders: [new ColumnNodeProvider(['METRIC_VIEW_USAGE'], {defaultValues: "Empty Metric View Usage"})],
            renderOptions: {}}
    ],

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const MetricViewSearch: ISearch = {
    searchName: "Find Metric View",
    renderOptions: { ui5ResourceId: "MetricViewSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [MetricViewSearchProfileByName]
}
_.forEach(vUI_Metric_View_Search_Fields, (colSpec) => {
    if(colSpec.domainOptions.bUseSearchProvidersDistinctValues && !colSpec.domainOptions.search)
        colSpec.domainOptions.search = MetricViewSearch
})

PAEnvironment.registerBusinessObjectSearch("MetricViewBO", "MetricView", MetricViewSearch, "Metric View Search")

export {MetricViewSearch}

